import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { SWRConfig } from "swr";
import store from "./store";
import "./locales/i18n";
import App from "./app";
import "./assets/css/material-dashboard-pro-react.css";
import "./assets/scss/material-dashboard-pro-react.scss";
import { fetcher } from "./lib/api";
import { AppThemeProvider } from "./theme/ThemeProvider";
import { applyTheme, getStoredPreference, resolveTheme } from "./utils/theme";

import Hotjar from "@hotjar/browser";

// Apply before first paint (also bootstrapped in index.html).
applyTheme(resolveTheme(getStoredPreference()));

const originalError = window.onerror;
window.onerror = (message, ...args) => {
    if (typeof message === 'string' && message.includes('ResizeObserver loop')) return true;
    return originalError ? originalError(message, ...args) : false;
};
window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation();
        e.preventDefault();
    }
}, true);

const siteId = 5180361;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

const root = ReactDOMClient.createRoot(document.getElementById("root"));

root.render(
    <Provider store={store}>
        <SWRConfig
            value={{
                fetcher,
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
            }}
        >
            <AppThemeProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </AppThemeProvider>
        </SWRConfig>
    </Provider>
);
